import { z } from "zod";
//
// Entity
//
export const DTOStorybookUploadStatus = z.enum([
    "PendingUpload",
    "Failed",
    "InProgress",
    "Completed",
    "Timeout",
]);
export const DTOStorybookSiteVersion = z.object({
    id: z.string(),
    isPublic: z.boolean(),
    createdAt: z.string(),
    uploadStatus: DTOStorybookUploadStatus,
});
export const DTOStorybookSite = z.object({
    id: z.string(),
    designSystemId: z.string(),
    name: z.string(),
    indexPageUrl: z.string(),
    createdAt: z.string(),
    currentVersion: DTOStorybookSiteVersion,
});
//
// Payloads
//
export const DTOStorybookSiteListQuery = z.object({
    designSystemId: z.string(),
});
export const DTOStorybookSiteListResponse = z.object({
    sites: DTOStorybookSite.array(),
});
export const DTOStorybookSiteUploadPayload = z.object({
    designSystemId: z.string(),
    isPublic: z.boolean(),
    name: z.string(),
});
export const DTOStorybookSiteUploadResponse = z.object({
    storybookSiteVersion: DTOStorybookSiteVersion,
    uploadUrl: z.string(),
});
export const DTOStorybookSiteVersionResponse = z.object({
    storybookSiteVersion: DTOStorybookSiteVersion,
});
